import axios from 'axios'

export default {
    updateRate(rate) {
        return axios.put('online-lesson-rate/' + rate.id, rate).then(response => {
            return response.data
        })
    },

    createRate(rate) {
        return axios.post('online-lesson-rate', rate).then(response => {
            return response.data
        })
    },

    deleteRate(id) {
        return axios.delete('online-lesson-rate/' + id).then(response => {
            return response.data
        })
    },

    fetchRate(id) {
        return axios.get('online-lesson-rate/' + id)
            .then(response => {
                return response.data
            })
    },

    fetchRates() {
        return axios.get('online-lesson-rate').then(response => {
            return response.data
        })
    },

    fetchRateByLessonId(lessonId) {
        return axios.get('online-lesson-rate?lesson_id=' + lessonId).then(response => {
            if (response.data.length > 0) return response.data[0]
        })
    },
}
